import { MutationTree } from 'vuex';
import { Account, RandomizableAccount } from '../account/types';
import { IdpAccountState } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';
import { NodeIdp } from '../node_idp/types';

// 全てのエラーをクリアする
const resetAllErrors = (state: IdpAccountState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const directSearchState = state.directSearch;
    directSearchState.error = false;
    directSearchState.errorCode = undefined;
    directSearchState.errorMsg = undefined;

    const createState = state.create;
    createState.error = false;
    createState.errorTitle = undefined;
    createState.errorDetails = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;
};

export const mutations: MutationTree<IdpAccountState> = {
    // IdPアカウント検索系
    [types.SEARCH_START](state) {
        resetAllErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; idp_accounts: Array<Account> }) {
        state.idpAccountCount = payload.count;
        state.idpAccounts = payload.idp_accounts;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // IdPアカウント検索系（IdP内の検索）
    [types.DIRECT_SEARCH_START](state) {
        resetAllErrors(state);
        const directSearchState = state.directSearch;
        directSearchState.isProcessing = true;
        directSearchState.isFetchSuccess = false;
    },

    [types.DIRECT_SEARCH_SUCCESS](state, payload: { idp_accounts: Array<Account> }) {
        state.wkIdpAccountCount = payload.idp_accounts.length;
        state.wkIdpAccounts = payload.idp_accounts;

        const directSearchState = state.directSearch;
        directSearchState.isProcessing = false;
        directSearchState.isFetchSuccess = true;
    },

    [types.DIRECT_SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const directSearchState = state.directSearch;
        directSearchState.errorCode = payload.code;
        directSearchState.errorMsg = payload.message;
        directSearchState.error = true;
        directSearchState.isProcessing = false;
        directSearchState.isFetchSuccess = false;
    },

    // IdPアカウント新規登録
    [types.CREATE_START](state) {
        resetAllErrors(state);
        const createState = state.create;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
        createState.isCreated = true;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // IdPアカウント詳細情報参照系
    [types.SHOW_START](state) {
        resetAllErrors(state);
        const showState = state.show;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload: { idp_account: Account; idp: NodeIdp }) {
        state.idpAccountDetails.idp_account = payload.idp_account;
        state.idpAccountDetails.idp = payload.idp;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // IdPアカウント削除系
    [types.DESTROY_START](state) {
        resetAllErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // IdPアカウント検索済みデータ削除
    [types.CLEAR_WORK](state) {
        state.wkIdpAccountCount = 0;
        state.wkIdpAccounts = undefined;
    },

    // エラーのみリセットする
    [types.RESET_ERROR](state) {
        resetAllErrors(state);
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const directSearchState = state.directSearch;
        directSearchState.isProcessing = false;
        directSearchState.isFetchSuccess = false;

        const createState = state.create;
        createState.isProcessing = false;

        const showState = state.show;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    // エラーのみリセットする
    [types.CLEAR_ALL](state) {
        resetAllErrors(state);

        state.idpAccounts = undefined;
        state.idpAccountCount = 0;
        state.idpAccountDetails.idp_account = undefined;
        state.idpAccountDetails.idp = undefined;

        state.wkIdpAccounts = undefined;
        state.wkIdpAccountCount = 0;
    },
};
